import VideoSpiller, { type Props } from '@helsenorge/core-cms/videospiller';
import type { VimeoSubtitleLanguageCodes } from '@helsenorge/core-cms/videospiller/constants';

export interface VideoBlockProps extends Props {
  subtitleLanguageCode: VimeoSubtitleLanguageCodes;
}

const VideoFeatureBlock: React.FunctionComponent<VideoBlockProps> = ({ subtitleLanguageCode, ...rest }) => (
  <VideoSpiller subtitleLanguageCode={subtitleLanguageCode} {...rest} />
);

export default VideoFeatureBlock;
